import styled from "styled-components";
import { colours } from "../../../../styles/colours.constants";
import { satoshi500, satoshi900 } from "../../../../styles/font.constants";

export const ToolbarStat = styled.div`
	position: relative;
	display: flex;
	gap: 0.4rem;
`;

export const DisplayContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 0.2rem;
`;

export const Value = styled.div`
	${satoshi900};
	color: ${colours.black};
	font-size: 1.25rem;
	cursor: default;
`;

export const Label = styled.div`
	${satoshi500};
	color: ${colours.greyDarker};
	font-size: 1rem;
	cursor: default;
`;
